import { PerformedSearchRequestContext } from 'clientState/providers/SearchRequestProvider';
import ItemCollector from '../../../Filters/queries/ItemCollector';
import ByLegCollector from '../../FiltersAccordion/queries/ByLegCollector';
import { Carrier, SegmentFragment, TransportType } from 'generated/graphql';

const joinCarrierLegItems = (carriersGroupedByLeg) => {
  const carriers = carriersGroupedByLeg.reduce(
    (groupedCarriers, { carriers }) => {
      return carriers.reduce((result, carrier) => {
        return result.set(carrier.id, carrier);
      }, groupedCarriers);
    },
    new Map()
  );
  return [
    {
      ...carriersGroupedByLeg[0],
      carriers: Array.from(carriers.values()),
    },
  ];
};

type CollectorCarrier = Carrier & {
  checked: boolean;
  transportType: TransportType;
};

type CarrierLegCollectorReturnType = {
  add: (carrier: CollectorCarrier) => void;
  build: () => { carriers: CollectorCarrier[] };
};
const CarrierLegCollector = (): CarrierLegCollectorReturnType => {
  const collector = ItemCollector<CollectorCarrier>();
  return {
    add(carrier) {
      collector.add(carrier);
    },
    build() {
      const carriers = collector.build();
      return { carriers };
    },
  };
};

const defaultAirlineCodes = {
  has: () => true,
};

const CarrierCollector = (searchRequest: PerformedSearchRequestContext) => {
  const airlineCodes = searchRequest.airlineCodes
    ? new Set(searchRequest.airlineCodes)
    : defaultAirlineCodes;
  const collector = ByLegCollector(CarrierLegCollector);
  return {
    add(legIndex: number, segment: SegmentFragment) {
      const checked = airlineCodes.has(segment.carrier.id);
      collector.add(legIndex, {
        ...segment.carrier,
        checked,
        transportType: segment.transportTypes[0],
      });
    },
    build() {
      let carriers = collector.build();
      if (searchRequest.tripType === 'ROUND_TRIP') {
        carriers = joinCarrierLegItems(carriers);
      }
      return carriers.map(({ id, carriers: legCarriers }) => {
        const sorted = legCarriers.sort(({ name: a }, { name: b }) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
        return { legId: id, carriers: sorted };
      });
    },
  };
};

export default CarrierCollector;
